// Contact form endpoint. The form posts to Formspree.
//
// Setup: create a form at https://formspree.io (or reuse an existing one), then
// paste its id below. The id is the part after /f/ in the endpoint URL
// https://formspree.io/f/<id>. Until a real id is set the form falls back to a
// plain mailto link so the page is never broken.
const CONTACT_CONFIG = {
	formspreeId: "mgawwjnj",
};

export const FORMSPREE_ENDPOINT = `https://formspree.io/f/${CONTACT_CONFIG.formspreeId}`;

export const FORMSPREE_READY =
	CONTACT_CONFIG.formspreeId !== "REPLACE_WITH_FORMSPREE_ID";

export default CONTACT_CONFIG;
